import React from "react";
import {
    Modal,
    Box,
    Typography,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import popup from "../../images/popup_design.png";
import { Star } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const PremiumModal = ({ onClose, daysLeft }) => {
    const navigate = useNavigate();

    const handleUpgradeClick = () => {
        navigate("/upgrade"); // Navigate to /upgrade when clicked
        onClose();
      };
    return (
        <Modal open={true} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "white",
                    borderRadius: 3,
                    boxShadow: 24,
                    p: 3,
                    textAlign: "center",
                    background: `url('${popup}') no-repeat center center/cover`, // Add your background image here
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h6" fontWeight="bold" color="#a52a8a" sx={{ padding: 2,   fontFamily: "'Playfair Display', serif" }}>
                        Your Premium Membership is About to Expire!
                    </Typography>
                    <IconButton onClick={onClose}
                        sx={{
                           
                            position: "absolute",
                            top: 2,
                            right: 2,
                            padding: "4px", // Remove any padding if needed
                            //   color: "white",
                            cursor: "pointer",
                            backgroundColor: "white", // Adjust the background color as needed
                        }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Typography
                    sx={{ mt: 2, mb: 3 }}
                    variant="body1"
                    color="#8b008b"
                    fontSize="0.9rem"
                >
                    Benefits of Upgrading
                </Typography>

                <List>
                    {[
                        "Continue accessing exclusive profiles",
                        "Stay ahead with top recommendations",
                        "Enjoy enhanced visibility",
                    ].map((benefit, index) => (
                        <ListItem key={index}>
                            <ListItemIcon>
                                <CheckCircleIcon color="success" />
                            </ListItemIcon>
                            <ListItemText primary={benefit} />
                        </ListItem>
                    ))}
                </List>

                <Typography
                    sx={{ mt: 2, fontStyle: "italic", color: "#555" }}
                    variant="body2"
                >
                    Only {daysLeft} Days Left to Renew Your Premium Membership!
                </Typography>

                <Button
                    variant="contained"
                    sx={{
                        mt: 3,
                        background: "linear-gradient(90deg, #B60202 0%, #500101 100%)",
                        color: "white",
                        borderRadius: 3,
                        padding: "10px 20px",
                    }}
                    onClick={handleUpgradeClick}
                >
                    Upgrade to Pro
                    <Star sx={{ ml: 1, color: "white", fontSize: "20px" }} />
                </Button>


            </Box>
        </Modal>
    );
};

export default PremiumModal;
